import { deepEquals, isEmpty } from "@swa-ui/object";

const DEFAULT_ERROR_CODE = "000999999";

export function getResponseErrors(response) {
  const { status, data: responseData } = response;
  const fallbackData = responseData ?? response ?? {};
  const serviceData = responseData?.data ?? fallbackData;
  let responseErrors = [];

  if (status === 207 && Array.isArray(serviceData)) {
    responseErrors = serviceData.map(getResponseErrors).flat();
  } else {
    const { code, errors = [], screen } = serviceData;
    // Check multiple locations for notifications to handle inconsistent API response structures.
    // Some APIs nest notifications under serviceData, others at responseData root level.
    const notifications = serviceData?.notifications ?? fallbackData?.notifications ?? {};
    const fieldErrors = notifications?.fieldErrors ?? [];
    const formErrors = notifications?.formErrors ?? [];

    responseErrors = [...(code ? [{ code, ...(screen && { screen }) }] : [])]
      .concat(
        errors.map((error, index) => ({ ...error, ...(index === 0 && screen && { screen }) }))
      )
      .concat(formErrors.map((error) => ({ code: error.trackingCode })))
      .concat(fieldErrors.map((error) => ({ code: error.trackingCode })))
      .filter(isNotUndefinedNull);
  }

  responseErrors = setDefaultError(response, responseErrors);

  return responseErrors;
}

export function isNotUndefinedNull(index) {
  return index !== undefined && index !== null;
}

function setDefaultError(response, responseErrors) {
  const hasResponseStructure = "ok" in response || "data" in response;
  const hasNoValidOk = response?.ok !== true;
  const hasNoValidData = !isNotUndefinedNull(response?.data);
  let errorList = [];

  if (isEmpty(responseErrors) && hasResponseStructure && hasNoValidOk && hasNoValidData) {
    errorList = [{ code: DEFAULT_ERROR_CODE }];
  }

  return [...errorList, ...responseErrors].filter(
    (error, index, responseErrorArray) =>
      responseErrorArray.findIndex((item) => deepEquals(item, error)) === index
  );
}
